import IHeaderMenuItem from "./IHeaderMenuItem";

export default interface IDocSection {
  section: string;
  headerMenu: IHeaderMenuItem[];
}

export const getApiDocSection = (section: string, product: string, docProject: string, type: string): IDocSection => {
  return {
    section,
    headerMenu: [
      {
        name: "Reference",
        href: `/docs?id=${docProject}/restapi/api/${type}/index.html`,
        startsWith: `/docs?id=${docProject}/restapi/api/${type}`,
      },
      {
        name: "Try It Out",
        href: `/try-it-out/${product}/${type}`,
        startsWith: `/try-it-out/${product}/${type}`,
      },
    ],
  };
};
